import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import { Ad } from 'modules/ads';
import { ContentArea, ContentDescription } from './components';
import container from './MainColumn.container';

const useStyles = makeStyles((theme) => ({
  slot728: {
    minHeight: 90,
    background: theme.palette.paperColor
  },
  slot300: {
    minWidth: 300,
    minHeight: 250,
    background: theme.palette.paperColor,
    textAlign: 'center'

  },
  sticky: {
    position: 'sticky',
    top: 50,
    zIndex: 9999
  },
}));

const MainColumn = (props) => {
  const classes = useStyles();
  const { siteCoordinator, audioPlayer } = props;

  /*const prevScrollY = useRef(0);

  const [scrollable, setScrollable] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > 595) {
        setScrollable(true);
      } else {
        setScrollable(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollable]);*/

  return (
    <>
      <Hidden xsDown>
        <Ad
          className={classes.slot728}
          adContainer="top_ad_fixed"
          adName="desktop_top_ad_fixed"
          slotName="top_ad"
          divId={'div-gpt-ad-1468352687772-0'}
          noReport={true}
        />
      </Hidden>
      <ContentArea currentTab={siteCoordinator.currentTab} position={'top'} audioPlayer={audioPlayer}/>
      <Hidden xsDown>
        <Ad
          /*parentClassName={clsx({
            [classes.sticky]: scrollable
          })}*/
          className={classes.slot728}
          adContainer="middle_ad_fixed"
          adName="desktop_middle_ad_fixed"
          slotName="middle_ad"
          divId={'div-gpt-ad-1468352646628-0'}
          noReport={true}
        />
      </Hidden>
      <Hidden smUp>
        <Ad
          className={classes.slot300}
          adContainer="advert_middle_mobile"
          adName="mobile_ad_main"
          slotName="mobile_main"
          divId={'div-gpt-ad-1439940510838-0'}
          noReport={true}
        />
      </Hidden>
      <ContentArea
        currentTab={siteCoordinator.currentTab}
        position={'bottom'}
        audioPlayer={audioPlayer}
      />
      <ContentDescription />
      <div id="primis-holder">
        <div id="primis-player" className="pp"></div>
      </div>
    </>
  );
};

export default container(MainColumn);
